import { createComponents } from '@swell/apps-sdk-next/components';
import api from 'services/api';

const { CLIENT_URL } = process.env;

// The store's own host serves the storefront API that lists components
function storeUrl(clientId) {
  return new URL(CLIENT_URL.replace('CLIENT_ID', clientId)).origin;
}

let instance = null;
let instanceKey = null;

/**
 * The app components client for the current store. Metadata comes from the
 * storefront API with the store's public key; tokens come from the dashboard
 * session, so components can call their app's functions as this admin.
 * @param {{ id: string, public_key: string }} client
 * @returns {object}
 */
export function getAppComponents(client) {
  const key = `${client.id}:${client.public_key}`;
  if (!instance || instanceKey !== key) {
    instance = createComponents({
      storeId: client.id,
      publicKey: client.public_key,
      url: storeUrl(client.id),
      getToken: (app) => api.post(`/apps/${app}/component-token`),
    });
    instanceKey = key;
  }
  return instance;
}

/** Tests start without a cached instance */
export function resetAppComponents() {
  instance = null;
  instanceKey = null;
}
